/** @format */
import lang_route from './lang_route.json';
import lang_broker from './lang_broker.json';
import lang_common from './lang_common.json';
import lang_footer from './lang_footer.json';
import lang_header from './lang_header.json';

const swedish = {
  lang_route,
  lang_broker,
  lang_common,
  lang_header,
  lang_footer
};

export default swedish;
